import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "container"]

  connect() {
    // console.log("Hello, MultiRecords!", this.element)
  }

  // Add nested item
  add () {
    // console.log('add');
    const elm= event.currentTarget;

    const next_row= this.containerTarget.querySelector('[data-row-nr].hide')
    if (next_row) {
      next_row.classList.remove('hide');

      // Remove current Add button and any tooltip
      $(elm).tooltip('hide');
      elm.classList.add('hide');

      // Be sure to have the Add button in the last visible row
      unhide_last_multi_record_add_btn(this.containerTarget);
    }
    event.stopPropagation();
    event.preventDefault();

  }

  // Remove nested item
  remove () {
    // console.log('remove');
    const item_nr= parseInt(event.currentTarget.dataset.multiRecordsItemNr);

    // Find current row and hide it
    const current_row= this.containerTarget.querySelector("[data-row-nr='" + item_nr + "']");
    if (current_row) {
      $(event.currentTarget).tooltip('hide');
      current_row.classList.add('hide');

      // Blank out address field
      const addressField= current_row.querySelector("input[name*='address']");
      if (addressField) addressField.value= null; 
    }

    // Be sure to have the Add button in the last visible row
    unhide_last_multi_record_add_btn(this.containerTarget);

    event.stopPropagation();
    event.preventDefault();    

  }
}

function unhide_last_multi_record_add_btn(container) {
  // Find Add button in last visible row and unhide it unless all rows are visible
  let total_rows_length= container.querySelectorAll('[data-row-nr]').length;
  let visible_add_btns= container.querySelectorAll('[data-row-nr]:not(.hide) button.add')
  if (visible_add_btns) {
    if (visible_add_btns.length < total_rows_length ) {
      let last_add_btn= visible_add_btns[visible_add_btns.length-1];

      // So should not be the very last row
      last_add_btn.classList.remove('hide');
    };
  }
}